import { render, staticRenderFns } from "./xcgl.vue?vue&type=template&id=4bfd3d44&scoped=true"
import script from "./xcgl.vue?vue&type=script&lang=js"
export * from "./xcgl.vue?vue&type=script&lang=js"
import style0 from "./xcgl.vue?vue&type=style&index=0&id=4bfd3d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd3d44",
  null
  
)

export default component.exports